export const REMISE = 'Remise';
export const NORMAL = 'Normal';
export const COMMENTAIRE = 'Commentaire';
export const REGROUPEMENT = 'Regroupement';

export const JOUR = 'Jour';
export const SEMAINE = 'Semaine';
export const MOIS = 'Mois';
export const ANNEE = 'Annee';
export const UNITE = 'Unite';
export const POURCENTAGE = 'Pourcentage';

export const MONTANT = 'Montant';

export const TYPE_DEVIS = 'Devis';

export const SENS_VENTE = 'vente';
export const SENS_ACHAT = 'achat';

export const MODULE_GESTION_COMMERCIALE = 'GestionCommerciale';
export const MODULE_ACHAT = 'Achat';


export const ETAT_BROUILLON = 'Brouillon';
export const ETAT_ENREGISTRE = 'Enregistre';
export const ETAT_SANSSUITE = 'SansSuite';
export const ETAT_ENCOURS = 'EnCours';
export const ETAT_COMMANDE = 'Commande';
export const ETAT_COMMANDE_PARTIELLEMENT = 'CommandePartiellement';

export const TYPE_REFERENCE_EXTERNE_VENTE_DEVIS = 'DevisVente';

export const PERSONALISE = 'Personalise';

export const TYPE_REMISE_CUMULE = 'Cumule';
export const TYPE_REMISE_CASCADE = 'Cascade';
export const TYPE_REMISE_SOUS_TOTAL = 'SousTotal';

export const DEVIS_ACHAT_ETAT = [
  { code: ETAT_BROUILLON, libelle: 'listeDevisAchat.etat.brouillon' },
  { code: ETAT_ENREGISTRE, libelle: 'listeDevisAchat.etat.enregistre' },
  { code: ETAT_SANSSUITE, libelle: 'listeDevisAchat.etat.sansSuite' },
];

export const TYPES_QUANTITE = [
  { code: JOUR,    libelle: 'general.quantity.day' },
  { code: SEMAINE, libelle: 'general.quantity.week' },
  { code: MOIS,    libelle: 'general.quantity.month' },
  { code: ANNEE,   libelle: 'general.quantity.year' },
  { code: UNITE,   libelle: 'general.quantity.unity' },
];
